/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Raifragen } from '../../models/raifragen';

export interface ApiRaifragenGet$Plain$Params {
}

export function apiRaifragenGet$Plain(http: HttpClient, rootUrl: string, params?: ApiRaifragenGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<Raifragen>>> {
  const rb = new RequestBuilder(rootUrl, apiRaifragenGet$Plain.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<Raifragen>>;
    })
  );
}

apiRaifragenGet$Plain.PATH = '/api/Raifragen';
